import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import classes from "./Inputs.module.css";

function Input(props) {
  const { label, name, ...rest } = props;
  return (
    <div className={classes.FormGroup}>
      {label && <label htmlFor={name}>{label}</label>}
      <Field id={name} name={name} className={classes.InputStyle} {...rest} />
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default Input;
